module.exports = __webpack_public_path__ + "static/media/tvicon.3ae6c099.png";